import logger from '@eventbrite/client-logger';
import { logEvent } from '@eventbrite/statsig';
import isEmpty from 'lodash/isEmpty';
import { Dispatch } from 'redux';
import { updateOrderSurveyAnswersAfterPlacement } from '../../api/order';
import { FormSurveyAnswer } from '../../models/forms';
import { CheckoutState } from '../../state';
import { getFailedSurveyAnswersIds } from '../../utils/surveys';
import { showPurchaseConfirmation } from '../purchaseConfirmation';
import { handleAnalyticsTokenOnError } from '../tokens';
import { handleOrderError } from './utils';

export const updateOrderWithOptionalOrganizerQuestions =
    (
        orderId: string,
        surveyAnswers: Array<FormSurveyAnswer>,
        skipErroredAnswers: boolean,
        optionalQuestionAnswerRatio: string,
    ) =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        if (isEmpty(surveyAnswers)) {
            logEvent(optionalQuestionAnswerRatio);
            return dispatch(showPurchaseConfirmation());
        }

        try {
            await updateOrderSurveyAnswersAfterPlacement(
                orderId,
                surveyAnswers,
            );
        } catch (error) {
            logger.error(error);
            if (!skipErroredAnswers) {
                handleAnalyticsTokenOnError(dispatch, getState);
                return handleOrderError(dispatch, error);
            }
            const validSurveyAnswers = _cleanErroredOptionalOrganizerQuestions(
                surveyAnswers,
                error,
            );
            try {
                await updateOrderSurveyAnswersAfterPlacement(
                    orderId,
                    validSurveyAnswers,
                );
            } catch (error) {
                logger.error(error);
                handleAnalyticsTokenOnError(dispatch, getState);
            }
        }

        logEvent(optionalQuestionAnswerRatio);
        return dispatch(showPurchaseConfirmation());
    };

export const _cleanErroredOptionalOrganizerQuestions = (
    surveyAnswers: Array<FormSurveyAnswer>,
    error: Error,
) => {
    const failedAnswersIds = new Set(getFailedSurveyAnswersIds(error));
    return Object.keys(surveyAnswers)
        .filter((answerKey) => !failedAnswersIds.has(answerKey))
        .map((answerKey) => surveyAnswers[answerKey as unknown as number]);
};
